// ✅ CheckCircleIcon.tsx
const CheckCircleIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,24C5.383,24,0,18.617,0,12S5.383,0,12,0s12,5.383,12,12-5.383,12-12,12Zm0-22C6.486,2,2,6.486,2,12s4.486,10,10,10,10-4.486,10-10S17.514,2,12,2Zm6.293,6.293-7.293,7.293-3.293-3.293a.99991.99991,0,0,0-1.414,1.414l4,4a.99962.99962,0,0,0,1.414,0l8-8A.99989.99989,0,1,0,18.293,8.293Z"/>
  </svg>
);

export default CheckCircleIcon;
